<template>
  <!-- 服务时长明细弹窗 -->
  <a-modal title="服务时长明细" :visible="visible" @cancel="handleClose" :width="1200" :footer="null">
    <!-- 条件搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 空间ID筛选 -->
          <a-col :md="8" :sm="24">
            <a-form-item label="空间ID">
              <a-input
                v-model:value="queryParam.spaceId"
                placeholder="请输入空间ID"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <!-- 日期筛选 -->
          <a-col :md="8" :sm="24">
            <a-form-item label="日期">
              <a-date-picker
                v-model:value="queryParam.stayDate"
                style="width: 100%"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="请选择日期"
                allow-clear
                class="no-border-radius-picker"
              />
            </a-form-item>
          </a-col>
          <!-- 按钮区域：收起状态时在第一行 -->
          <a-col v-if="!expandSearch" :md="8" :sm="24">
            <a-form-item>
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery" class="search-button"> <SearchOutlined />查询 </a-button>
                <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                  重置
                </a-button>
                <a-button style="margin-left: 8px" @click="toggleExpandSearch" class="no-border-button toggle-button">
                  {{ expandSearch ? '收起' : '展开' }}
                  <UpOutlined v-if="expandSearch" />
                  <DownOutlined v-else />
                </a-button>
              </span>
            </a-form-item>
          </a-col>

          <!-- 高级搜索：补充剩余字段 -->
          <template v-if="expandSearch">
            <!-- 空间名称筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="空间名称">
                <a-input
                  v-model:value="queryParam.spaceName"
                  placeholder="请输入空间名称"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 员工姓名筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="员工姓名">
                <a-input
                  v-model:value="queryParam.employeeName"
                  placeholder="请输入员工姓名"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 进入时间筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="进入时间">
                <a-date-picker
                  v-model:value="queryParam.entryTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  show-time
                  placeholder="请选择进入时间"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>
            <!-- 离开时间筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="离开时间">
                <a-date-picker
                  v-model:value="queryParam.departureTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  show-time
                  placeholder="请选择离开时间"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>
            <!-- 服务时长筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="服务时长(分钟)">
                <a-input-number
                  v-model:value="queryParam.stayDuration"
                  :min="0"
                  :step="1"
                  placeholder="请输入服务时长(分钟)"
                  allow-clear
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 空间性质筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="空间性质">
                <a-select
                  v-model:value="queryParam.spatialProperties"
                  placeholder="请选择空间性质"
                  allow-clear
                  style="width: 100%"
                  class="no-border-radius-select"
                >
                  <a-select-option
                    v-for="dict in dict.type['spatial_properties']"
                    :key="dict.value"
                    :value="dict.value"
                  >
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 当前所属项目筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="当前所属项目">
                <a-input
                  v-model:value="queryParam.projectName"
                  placeholder="请输入当前所属项目"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 所属公司筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="所属公司">
                <a-input
                  v-model:value="queryParam.companyName"
                  placeholder="请输入所属公司"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 按钮区域：展开状态时在最后一行末尾 -->
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    <SearchOutlined />查询
                  </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleExpandSearch" class="no-border-button toggle-button">
                    {{ expandSearch ? '收起' : '展开' }}
                    <UpOutlined v-if="expandSearch" />
                    <DownOutlined v-else />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operations" style="margin-bottom: 16px">
      <a-button
        type="text"
        shape="circle"
        @click="handleRefresh"
        v-hasPermi="refreshPermission"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button
        @click="handleExport"
        :disabled="!list || list.length === 0 || pagination.total === 0"
        v-hasPermi="exportPermission"
        class="no-border-button export-button"
      >
        <UploadOutlined />导出
      </a-button>
      <a-button :disabled="multiple" @click="handleDelete" v-hasPermi="removePermission" class="no-border-button">
        <DeleteOutlined />删除
      </a-button>
    </div>
    <!-- 数据表格 -->
    <div v-if="list && list.length > 0">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :loading="loading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          fixed: true,
        }"
        rowKey="id"
        :scroll="{ x: true }"
        size="small"
        class="optimized-table"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, text, record, index }">
          <!-- 序号列：计算显示序号 -->
          <template v-if="column.dataIndex === 'id'">
            <span>
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
            </span>
          </template>
          <!-- 空间名称列：显示空间名称，如果记录中没有则使用props传入的空间名称 -->
          <template v-else-if="column.dataIndex === 'spaceName'">
            <span>
              {{ record.spaceName || spaceName || '-' }}
            </span>
          </template>
          <!-- 员工姓名列：显示员工姓名，如果记录中没有则使用props传入的员工姓名 -->
          <template v-else-if="column.dataIndex === 'employeeName'">
            <span>
              {{ record.employeeName || employeeName || '-' }}
            </span>
          </template>
          <!-- 进入时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'entryTime'">
            <span>
              {{ parseTime(record.entryTime) }}
            </span>
          </template>
          <!-- 离开时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'departureTime'">
            <span>
              {{ parseTime(record.departureTime) }}
            </span>
          </template>
          <!-- 空间性质列 -->
          <template v-else-if="column.dataIndex === 'spatialProperties'">
            <span>
              <dict-tag :options="dict.type['spatial_properties']" :value="record.spatialProperties" />
            </span>
          </template>
          <!-- 操作列 -->
          <template v-else-if="column.dataIndex === 'operation'">
            <span>
              <a-divider type="vertical" v-hasPermi="removePermission" />
              <a @click="handleDelete(record)" v-hasPermi="removePermission" class="delete-link"> 删除 </a>
            </span>
          </template>
          <!-- 其他字段：默认显示 text 值 -->
          <template v-else>
            <span>{{ text }}</span>
          </template>
        </template>
      </a-table>

      <!-- 分页组件 -->
      <div class="pagination-wrapper" v-if="list && list.length > 0">
        <div class="pagination-left">
          <span class="pagination-info">
            显示第 {{ (pagination.current - 1) * pagination.pageSize + 1 }} 到第
            {{ Math.min(pagination.current * pagination.pageSize, pagination.total) }} 条数据/共
            {{ pagination.total }} 条
          </span>
          <a-select
            v-model:value="pagination.pageSize"
            style="width: 100px; margin-left: 8px"
            @change="onShowSizeChange(pagination.current, pagination.pageSize)"
            class="no-border-radius-select"
          >
            <a-select-option :value="10">10条/页</a-select-option>
            <a-select-option :value="20">20条/页</a-select-option>
            <a-select-option :value="50">50条/页</a-select-option>
            <a-select-option :value="100">100条/页</a-select-option>
          </a-select>
        </div>
        <div class="pagination-right">
          <a-pagination
            :current="pagination.current"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :show-total="false"
            @change="changeSize"
          />
          <span class="pagination-jump">
            到第
            <a-input-number
              v-model:value="jumpPage"
              :min="1"
              :max="Math.ceil(pagination.total / pagination.pageSize)"
              style="width: 60px; margin: 0 4px"
              @pressEnter="handleJumpPage"
              class="no-border-radius-input-number"
            />
            页
          </span>
        </div>
      </div>
    </div>
    <!-- 空数据提示 -->
    <a-empty v-else description="暂无服务时长明细数据" style="padding: 60px 0" />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 服务时长明细组件
 * 功能：显示指定空间和员工的服务时长明细记录
 * - 支持按空间名称、员工姓名、日期筛选明细
 * - 支持分页查询和刷新
 * - 支持导出明细数据
 * - 通过props接收空间ID、员工ID、日期等筛选条件
 */
import { pageSpaceStayRecord, delSpaceStayRecord } from '@/api/system/spaceStayRecord'
import { tableMixin } from '@/store/table-mixin'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons-vue'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'SpaceStayRecord',
  mixins: [tableMixin],
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    UploadOutlined,
    DeleteOutlined,
  },
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 列表页点击行ID（用于明细查询）
    stayId: {
      type: Number,
      default: null,
    },
    // 项目ID（用于筛选）
    projectId: {
      type: Number,
      default: null,
    },
    // 公司ID（用于筛选）
    companyId: {
      type: Number,
      default: null,
    },
    // 空间ID（用于筛选）
    spaceId: {
      type: Number,
      default: null,
    },
    // 空间名称（用于显示在标题中）
    spaceName: {
      type: String,
      default: '',
    },
    // 员工ID（用于筛选）
    employeeId: {
      type: Number,
      default: null,
    },
    // 员工姓名（用于显示在标题中）
    employeeName: {
      type: String,
      default: '',
    },
    // 日期（用于筛选）
    stayDate: {
      type: String,
      default: null,
    },
    // 权限前缀，用于动态生成权限值
    permissionPrefix: {
      type: String,
      default: 'system:spaceStayRecord',
    },
  },
  dicts: ['spatial_properties'],
  data() {
    return {
      // 明细列表数据
      list: [],
      // 加载状态
      loading: false,
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 初始化标志，防止重复请求
      isInitializing: false,
      // 筛选项展开/收起状态（默认收起，只显示前三个筛选项）
      expandSearch: false,
      // 查询参数（与表格列字段保持一致）
      queryParam: {
        spaceId: undefined, // 空间ID
        stayDate: null, // 日期
        spaceName: undefined, // 空间名称
        employeeName: undefined, // 员工姓名
        entryTime: null, // 进入时间
        departureTime: null, // 离开时间
        stayDuration: undefined, // 服务时长(分钟)
        spatialProperties: undefined, // 空间性质
        projectName: undefined, // 当前所属项目
        companyName: undefined, // 所属公司
      },
      // 分页配置
      pagination: {
        current: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0, // 总条数
      },
      // 跳转页码
      jumpPage: 1,
      // 表格列配置
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
          width: 80,
        },
        {
          title: '空间ID',
          dataIndex: 'spaceId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },

        {
          title: '日期',
          dataIndex: 'stayDate',
          align: 'center',
          width: 120,
        },
        {
          title: '空间名称',
          dataIndex: 'spaceName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          align: 'center',
          width: 120,
        },
        {
          title: '进入时间',
          dataIndex: 'entryTime',
          align: 'center',
          width: 180,
        },
        {
          title: '离开时间',
          dataIndex: 'departureTime',
          align: 'center',
          width: 180,
        },
        {
          title: '服务时长(分钟)',
          dataIndex: 'stayDuration',
          align: 'center',
          width: 120,
        },
        {
          title: '空间性质',
          dataIndex: 'spatialProperties',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '当前所属项目',
          dataIndex: 'projectName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '所属公司',
          dataIndex: 'companyName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  computed: {
    /**
     * 刷新权限
     * 根据权限前缀动态生成刷新权限值
     */
    refreshPermission() {
      return [`${this.permissionPrefix}:refresh`]
    },
    /**
     * 导出权限
     * 根据权限前缀动态生成导出权限值
     */
    exportPermission() {
      return [`${this.permissionPrefix}:export`]
    },
    /**
     * 删除权限
     * 根据权限前缀动态生成删除权限值
     */
    removePermission() {
      return [`${this.permissionPrefix}:remove`]
    },
    /**
     * 是否禁用批量操作（删除）
     * 当没有选中数据时禁用
     */
    multiple() {
      return !this.selectedRowKeys || this.selectedRowKeys.length === 0
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开时，初始化数据
     */
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (!this.isInitializing) {
            this.init()
          }
        })
      } else if (!newVal) {
        // 弹窗关闭时重置初始化标志
        this.isInitializing = false
      }
    },
  },
  methods: {
    /**
     * 初始化数据
     * 重置分页、清空列表、重置查询条件，然后获取明细列表
     */
    init() {
      // 防止重复初始化
      if (this.isInitializing) {
        return
      }
      this.isInitializing = true

      // 重置分页到第一页
      this.pagination.current = 1
      this.pagination.total = 0
      this.jumpPage = 1
      // 清空列表数据
      this.list = []
      // 清空选中状态
      this.selectedRowKeys = []
      this.selectedRows = []
      // 重置查询条件，只保留项目ID、公司ID、空间ID的默认值，其他字段不设置默认值
      this.queryParam = {
        spaceId: undefined,
        stayDate: null,
        spaceName: undefined,
        employeeName: undefined,
        entryTime: null,
        departureTime: null,
        stayDuration: undefined,
        spatialProperties: undefined,
        projectName: undefined,
        companyName: undefined,
      }
      // 获取明细列表
      this.getList().finally(() => {
        // 请求完成后重置标志
        this.isInitializing = false
      })
    },

    /**
     * 获取服务时长明细列表
     * 根据空间ID、员工ID、日期和查询条件分页查询明细数据
     * @returns {Promise} 返回请求的 Promise
     */
    getList() {
      if (!this.stayId) {
        this.loading = false
        this.list = []
        this.pagination.total = 0
        this.jumpPage = 1
        return Promise.resolve()
      }
      // 开始加载
      this.loading = true

      // 明细分页接口只传 stayId/pageNum/pageSize
      const params = {
        stayId: this.stayId,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }

      // 发送请求并返回 Promise
      return pageSpaceStayRecord(params)
        .then((response) => {
          // 设置列表数据和总数
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
          // 同步跳转页码
          this.jumpPage = this.pagination.current
          this.loading = false
        })
        .catch(() => {
          // 请求失败，清空数据
          this.loading = false
          this.list = []
          this.pagination.total = 0
          this.jumpPage = 1
        })
    },

    /**
     * 查询操作
     * 重置到第一页并重新获取列表
     */
    handleQuery() {
      this.pagination.current = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 重置查询条件
     * 清空所有查询条件，重置到第一页并重新获取列表
     */
    handleReset() {
      // 重置查询条件，只保留项目ID、公司ID、空间ID的默认值，其他字段不设置默认值
      this.queryParam = {
        spaceId: undefined,
        stayDate: null,
        spaceName: undefined,
        employeeName: undefined,
        entryTime: null,
        departureTime: null,
        stayDuration: undefined,
        spatialProperties: undefined,
        projectName: undefined,
        companyName: undefined,
      }
      // 重置到第一页
      this.pagination.current = 1
      this.jumpPage = 1
      // 重新获取列表
      this.getList()
    },

    /**
     * 刷新列表
     * 重新获取当前条件下的明细列表
     */
    handleRefresh() {
      this.getList()
    },

    /**
     * 切换筛选项展开/收起状态
     * 控制是否显示额外的筛选项（默认只显示前三个）
     */
    toggleExpandSearch() {
      this.expandSearch = !this.expandSearch
    },

    /**
     * 导出明细数据
     * 支持导出选中数据或当前查询条件下的全部数据
     * - 如果选中了数据，则只导出选中的数据
     * - 如果没有选中数据，则导出当前查询条件下的全部数据
     */
    handleExport() {
      const that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      // 确认对话框
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          // 构建导出参数（与表格列字段保持一致）
          const params = {
            projectId: that.projectId,
            companyId: that.companyId,
            spaceId: that.queryParam.spaceId || that.spaceId,
            employeeId: that.employeeId,
            stayDate: that.queryParam.stayDate,
            spaceName: that.queryParam.spaceName,
            employeeName: that.queryParam.employeeName,
            entryTime: that.queryParam.entryTime,
            departureTime: that.queryParam.departureTime,
            stayDuration: that.queryParam.stayDuration,
            spatialProperties: that.queryParam.spatialProperties,
            projectName: that.queryParam.projectName,
            companyName: that.queryParam.companyName,
          }
          // 如果选中了数据，则传递ids参数
          if (hasSelection) {
            params.ids = that.selectedRowKeys
          }
          // 移除空值参数
          Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null || params[key] === '') {
              delete params[key]
            }
          })
          // 下载文件
          that.download(
            'system/space-stay-record/export',
            params,
            `服务时长明细_${that.spaceName || ''}_${that.employeeName || ''}_${new Date().getTime()}.xls`
          )
        },
        onCancel() {},
      })
    },

    /**
     * 删除明细数据
     * 支持删除选中数据或单条数据
     * @param {Object} record - 可选，要删除的单条记录。如果不传则删除选中的多条记录
     */
    handleDelete(record) {
      // 确定要删除的ID数组：如果传入了record则删除单条，否则删除选中的多条
      const ids = record ? [record.id] : this.selectedRowKeys
      if (!ids || ids.length === 0) {
        this.$message.warning('请先选择需要删除的数据', 3)
        return
      }
      const that = this
      // 确认删除对话框
      this.$confirm({
        title: '确认删除所选中数据?',
        content: `当前选中 ${ids.length} 条数据`,
        onOk() {
          // 构建删除参数：将ID数组转换为对象数组
          const data = ids.map((id) => ({ id }))
          return delSpaceStayRecord(data)
            .then(() => {
              that.$message.success('删除成功', 3)
              // 清空选中项
              that.onSelectChange([], [])
              // 重新加载列表
              that.getList()
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() {},
      })
    },

    /**
     * 关闭弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      $emit(this, 'close')
    },

    /**
     * 多选变化处理
     * 更新选中的行key和行数据
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    /**
     * 表格变化处理
     * 处理分页变化（页码、每页条数）
     * @param {Object} pagination - 分页对象
     */
    handleTableChange(pagination) {
      // 更新分页信息
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 同步跳转页码
      this.jumpPage = pagination.current
      // 分页变化时清空选择
      this.onSelectChange([], [])
      // 重新获取列表
      this.getList()
    },

    /**
     * 每页条数变化处理
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.current = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 分页变化处理
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },

    /**
     * 跳转页码处理
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.pagination.current = this.jumpPage
        this.getList()
      }
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
  padding-right: 12px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
  white-space: nowrap;
  overflow: visible;
}

/* 优化表单项间距 */
.table-page-search-wrapper :deep(.ant-form-item) {
  margin-bottom: 16px;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  width: 220px !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

/* 重置按钮样式 */
.reset-button {
  background: #f3f3f3 !important;
  color: #101010 !important;
  border: none !important;
}

.reset-button:hover {
  background: #e6e6e6 !important;
  color: #101010 !important;
  border: none !important;
}

.reset-button:focus {
  background: #f3f3f3 !important;
  color: #101010 !important;
  border: none !important;
}

/* 导出按钮样式 */
.export-button {
  background: #f3f3f3 !important;
  color: #101010 !important;
  border: none !important;
}

.export-button:hover {
  background: #e6e6e6 !important;
  color: #101010 !important;
  border: none !important;
}

.export-button:focus {
  background: #f3f3f3 !important;
  color: #101010 !important;
  border: none !important;
}

.export-button:disabled {
  background: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  border: none !important;
  cursor: not-allowed !important;
}

.export-button:disabled:hover {
  background: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  border: none !important;
}

/* 展开/收起按钮文字和图标颜色 */
.toggle-button {
  color: #165dff !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* 表格分页样式 */
:deep(.ant-pagination) {
  margin-top: 20px;
}

:deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-prev),
:deep(.ant-pagination-next),
:deep(.ant-pagination-prev .ant-pagination-item-link),
:deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-prev button),
:deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

:deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

:deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

:deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

:deep(.ant-pagination-options .ant-input-number) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-options .ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页组件样式 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
  line-height: 32px;
}

.pagination-right :deep(.ant-pagination) {
  display: flex;
  align-items: center;
  margin: 0;
  line-height: 32px;
  vertical-align: middle;
}

.pagination-right :deep(.ant-pagination-item),
.pagination-right :deep(.ant-pagination-prev),
.pagination-right :deep(.ant-pagination-next) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 32px;
  height: 32px;
}

.pagination-right :deep(.ant-pagination-item a),
.pagination-right :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-right :deep(.ant-pagination-next .ant-pagination-item-link) {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 32px;
  height: 32px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  line-height: 32px;
  height: 32px;
}

.pagination-jump :deep(.ant-input-number) {
  vertical-align: middle;
  line-height: 32px;
  height: 32px;
}

.pagination-jump :deep(.ant-input-number-input) {
  line-height: 32px;
  height: 32px;
}

.pagination-jump :deep(.ant-input-number-input-wrap) {
  line-height: 32px;
  height: 32px;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
  color: #000000 !important;
}

.pagination-wrapper :deep(.ant-input-number-input input) {
  color: #000000 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 操作列链接样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child a) {
  color: #165dff !important;
  cursor: pointer;
}

.optimized-table :deep(.ant-table-tbody > tr > td:last-child a:hover) {
  color: #4080ff !important;
}

/* 删除按钮颜色 - 红色 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child .delete-link) {
  color: #ff4d4f !important;
}

.optimized-table :deep(.ant-table-tbody > tr > td:last-child .delete-link:hover) {
  color: #ff7875 !important;
}
</style>
